import { NgModule } from '@angular/core';
import { NarrowSidebarLayoutComponent } from './components/narrow-sidebar-layout/narrow-sidebar-layout.component';
import { NarrowSidebarNavListComponent } from './components/narrow-sidebar-nav-list/narrow-sidebar-nav-list.component';
import { NarrowSidebarNavListItemDirective } from './directives/narrow-sidebar-nav-list-item.directive';
import { NarrowSidebarLogoDirective } from './directives/narrow-sidebar-logo.directive';
import { NarrowSidebarProfileComponent } from './components/narrow-sidebar-profile/narrow-sidebar-profile.component';
import { NarrowSidebarProfileImageDirective } from './directives/narrow-sidebar-profile-image.directive';
import { NarrowSidebarProfileMenuItemDirective } from './directives/narrow-sidebar-profile-menu-item.directive';
import { NarrowSidebarSearchDirective } from './directives/narrow-sidebar-search.directive';

const UI_COMPONENTS = [
  // Components
  NarrowSidebarLayoutComponent,
  NarrowSidebarNavListComponent,
  NarrowSidebarProfileComponent,

  // Directives
  NarrowSidebarNavListItemDirective,
  NarrowSidebarLogoDirective,
  NarrowSidebarProfileImageDirective,
  NarrowSidebarProfileMenuItemDirective,
  NarrowSidebarSearchDirective,
];

@NgModule({
  imports: UI_COMPONENTS,
  exports: UI_COMPONENTS,
})
export class SidebarLayoutModule {}
